import { css } from "styled-system/css";

export type BillingCycle = "monthly" | "annual";

export function BillingCycleToggle({
  value,
  onChange,
}: {
  value: BillingCycle;
  onChange: (cycle: BillingCycle) => void;
}) {
  return (
    <div
      className={css({
        display: "inline-flex",
        rounded: "full",
        bg: "white",
        borderWidth: "1px",
        borderColor: "#e2e8f0",
        p: "1",
        gap: "1",
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      })}
    >
      {(["monthly", "annual"] as const).map((cycle) => (
        <button
          key={cycle}
          type="button"
          onClick={() => onChange(cycle)}
          className={css({
            px: "5",
            py: "2",
            rounded: "full",
            fontSize: "sm",
            fontWeight: "semibold",
            cursor: "pointer",
            transition: "all 0.18s ease",
            bg: value === cycle ? "#1e1b4b" : "transparent",
            color: value === cycle ? "white" : "#64748b",
            display: "flex",
            alignItems: "center",
            gap: "2",
          })}
        >
          {cycle === "monthly" ? "Mensual" : "Anual"}
          {cycle === "annual" && value !== "annual" && (
            <span
              className={css({
                fontSize: "10px",
                fontWeight: "bold",
                bg: "#dcfce7",
                color: "#15803d",
                px: "1.5",
                py: "0.5",
                rounded: "full",
              })}
            >
              -24%
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
